var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/company-notice-result.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-2c5731cc!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/company-notice-result.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/CompanyNoticeResult.vue
// module id = 597
// module chunks = 1